export const mentionTypes = [{ type: '@' }, { type: '#' }];
